import client from '@/plugins/axios.js'

export default  {
  getAllBackorders(){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/order/backorders')
        .then((res)=>{
          //console.log('Backorders:service - call to backend succeeded:',res);
          resolve(res.data.data.primaryObject)
        })
        .catch((err)=>{
          reject(err)
        })
    });
  },
  requestDeliveryOfBackorder(payload){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).post('/api/order/backorder/' + payload.id + '/requestDelivery')
        .then((res)=>{
          //console.log('Backorders:service - call to backend succeeded:',res);
          resolve(res.data.data.primaryObject)
        })
        .catch((err)=>{
          reject(err)
        })
    });
    
  }
}
